import { TwemojiSprite } from '../../ui/emoji';
import spriteUrl from '../../ui/emoji/twitter/twemoji.png';

export const CoreAssets = {
    twemojiSprite: null as TwemojiSprite,
};

export const coreAssetsLoader = async () => {
    CoreAssets.twemojiSprite = await TwemojiSprite.load(spriteUrl);
};
